import React, { useState } from "react";
import { Header, Nav, Navbar } from "rsuite";

import Buttons from "../../../buttons/buttons";
import LayoutService from "../../../../services/layout.service";
import BottomSheet from "../../elements/bottom_sheet/BottomSheet";

import "./TopHeader.scss";

const TopHeader = () => {
  const [bottomSheetConfig, setBottomSheetConfig] = useState({});

  function bottomSheetHandler(config) {
    setBottomSheetConfig(config);
  }

  return (
    <div className="top-header">
      <Header>
        <Navbar appearance="inverse">
          <Navbar.Brand>
            <img src={LayoutService.getHeader().logo.original} alt="" />
          </Navbar.Brand>
          <Nav>
            <Buttons
              buttons={LayoutService.getHeader().buttons}
              bottomSheetConfig={bottomSheetConfig}
              bottomSheetHandler={bottomSheetHandler}
            />
          </Nav>
        </Navbar>
      </Header>

      <BottomSheet
        bottomSheetConfig={bottomSheetConfig}
        bottomSheetHandler={bottomSheetHandler}
        haveShowMore={bottomSheetConfig.id === "btn-app-bottom-sheet"}
      />
    </div>
  );
};

export default TopHeader;
